import script from "./highSeasSool.vue?vue&type=script&setup=true&lang=js"
export * from "./highSeasSool.vue?vue&type=script&setup=true&lang=js"

import "./highSeasSool.vue?vue&type=style&index=0&id=3fda61ce&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fda61ce"]])

export default __exports__